<div class="copo-datacenter-flex-box">
	<div class="copo-datacenter-layout-title" translate>datacenter.columns</div>
	<div class="copo-datacenter-layout-content">
		<div class="drag-container-wraper drag-container-right-border">
			<div class="drag-container">
				<h2 translate class="copo-datacenter-layout-content-header">eorder.fixed-columns</h2>
				<div class="drag-list">
					<button type="button" class="sort-element round-icon-container" (click)="addToSort(item)"
						*ngFor="let item of columnAggregatorList.scrollableColumns">
						<mat-icon *ngIf="!item.sortable" class="add-icon sort-icon add-icon-non-available"
								svgIcon="add"></mat-icon>
						<mat-icon *ngIf="!isAdded(item) && item.sortable" class="add-icon sort-icon"
								svgIcon="add"></mat-icon>
						<mat-icon *ngIf="isAdded(item) && item.sortable" class="remove-icon sort-icon"
								svgIcon="remove"></mat-icon>
						<div class="add-sort-box"
							[class.added-sort-box]="isAdded(item)"
							[class.non-available-sort-box]="!item.sortable">
							<span class="drag-box-added-label">{{item.header}}</span>
						</div>
					</button>
				</div>
			</div>
		</div>
		<div class="add-sort-container center">
			<div class="drag-container-header">
				<mat-icon [class.drag-icon-disactivated]="togglePosition"
						class="drag-icon small-icon-space-right" svgIcon="md:drag_indicator"></mat-icon>
				<copo-slide-button labelAfter="datacenter.sorting"
									labelBefore="datacenter.add-columns"
									(toggleChange)="onToggleChange()"
									[checked]="togglePosition">
				</copo-slide-button>
				<mat-icon [class.chevron-icon-activated]="togglePosition" class="chevron-icon-disactivated"
						svgIcon="sorting_icon"></mat-icon>
			</div>
			<div class="drag-container">
				<div class="drag-list drag-list-sort"
					cdkDropList
					#hidedList="cdkDropList"
					[cdkDropListData]="columnAggregatorList.allColumns">
					<div class="numbered-list-label">
						<div [class.sort-number-dark]="sortList.length >= 1" class="sort-number">1</div>
						<div [class.sort-number-dark]="sortList.length >= 2" class="sort-number">2</div>
						<div [class.sort-number-dark]="sortList.length >= 3" class="sort-number">3</div>
					</div>
					<div cdkDropList class="numbered-list" (cdkDropListDropped)="drop($event)">
						<div *ngFor="let item of sortList" class="empty-drag-box-container">
							<div class="empty-drag-box" cdkDrag>
								<mat-icon class="drag-icon small-icon-space-right"
										svgIcon="md:drag_indicator"></mat-icon>
								<span class="drag-box-added-label">{{item.header}}</span>
							</div>
							<div class="sort-button-box round-icon-container">
								<mat-icon (click)="setSortingOrder(item)"
										class="sort-icon "
										[svgIcon]="checkSortingOrder(item) === 'desc' ? 'sorting_down' : 'sorting_up'"></mat-icon>
							</div>
						</div>
						<div *ngFor="let i of[].constructor(3-sortList.length)"
							class="empty-drag-box-container">
							<div class="empty-drag-box" cdkDrag></div>
							<div class="sort-button-box round-icon-container sort-button-box-empty"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
